import AnimationType from "../enum/AnimationType";

export default function(input){

    switch(input){

        case AnimationType.FADE: return 'dmb-animation-fade';
        case AnimationType.SLIDE_LEFT: return 'dmb-animation-slideLeft';
        case AnimationType.SLIDE_RIGHT: return 'dmb-animation-slideRight';

        case AnimationType.BOUNCE: return 'dmb-animation-bounce';
        case AnimationType.BOUNCE_LEFT: return 'dmb-animation-bounceLeft';
        case AnimationType.BOUNCE_RIGHT: return 'dmb-animation-bounceRight';
        case AnimationType.BOUNCE_UP: return 'dmb-animation-bounceUp';
        case AnimationType.BOUNCE_DOWN: return 'dmb-animation-bounceDown';

        case AnimationType.FADE_LEFT: return 'dmb-animation-fadeLeft';
        case AnimationType.FADE_RIGHT: return 'dmb-animation-fadeRight';
        case AnimationType.FADE_UP: return 'dmb-animation-fadeUp';
        case AnimationType.FADE_DOWN: return 'dmb-animation-fadeDown';

        case AnimationType.FADE_BIG_LEFT: return 'dmb-animation-fadeBigLeft';
        case AnimationType.FADE_BIG_RIGHT: return 'dmb-animation-fadeBigRight';
        case AnimationType.FADE_BIG_UP: return 'dmb-animation-fadeBigUp';
        case AnimationType.FADE_BIG_DOWN: return 'dmb-animation-fadeBigDown';

        case AnimationType.FADE_TOP_LEFT: return 'dmb-animation-fadeTopLeft';
        case AnimationType.FADE_TOP_RIGHT: return 'dmb-animation-fadeTopRight';
        case AnimationType.FADE_BOTTOM_LEFT: return 'dmb-animation-fadeBottomLeft';
        case AnimationType.FADE_BOTTOM_RIGHT: return 'dmb-animation-fadeBottomRight';

        case AnimationType.FLIP: return 'dmb-animation-flip';
        case AnimationType.FLIP_VERTICAL: return 'dmb-animation-flipVertical';
        case AnimationType.FLIP_HORIZONTAL: return 'dmb-animation-flipHorizontal';

        case AnimationType.LIGHTSPEED_LEFT: return 'dmb-animation-lightspeedLeft';
        case AnimationType.LIGHTSPEED_RIGHT: return 'dmb-animation-lightspeedRight';

        case AnimationType.ROTATE: return 'dmb-animation-rotate';
        case AnimationType.ROTATE_DOWN_LEFT: return 'dmb-animation-rotateDownLeft';
        case AnimationType.ROTATE_DOWN_RIGHT: return 'dmb-animation-rotateDownRight';
        case AnimationType.ROTATE_UP_LEFT: return 'dmb-animation-rotateUpLeft';
        case AnimationType.ROTATE_UP_RIGHT: return 'dmb-animation-rotateUpRight';

        case AnimationType.ZOOM: return 'dmb-animation-zoom';
        case AnimationType.ZOOM_LEFT: return 'dmb-animation-zoomLeft';
        case AnimationType.ZOOM_RIGHT: return 'dmb-animation-zoomRight';
        case AnimationType.ZOOM_UP: return 'dmb-animation-zoomUp';
        case AnimationType.ZOOM_DOWN: return 'dmb-animation-zoomDown';

        case AnimationType.SLIDE_DOWN: return 'dmb-animation-slideDown';
        case AnimationType.SLIDE_UP: return 'dmb-animation-slideUp';

        default: return '';
    }
}